import React, { useCallback, useEffect, useMemo, useState } from 'react';
import './MiZona.css';
import { useTemporada } from '../../context/TemporadaContext';
import { actualizarPerfil, getEstadosPartido, getPartidos, getResumen } from '../../services/miZonaService';
import CabeceraJugador from './CabeceraJugador';
import FiltrosPartidos from './FiltrosPartidos';
import ModalRevision from './ModalRevision';
import TablaPartidos from './TablaPartidos';
import { agruparPorModalidad, indexarEstados } from './estadosPartido';
import { contarPorEstado, filtrarPorEstado } from './ordenPartidos';

// Zona personal del jugador (ruta /mi-area-personal, lado público). La caja de filtros va
// siempre encima de la cabecera.
export default function MiZona() {
  const { temporada } = useTemporada();
  const [resumen, setResumen] = useState(null);
  const [partidos, setPartidos] = useState([]);
  const [estados, setEstados] = useState({});
  const [error, setError] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [filtroEstado, setFiltroEstado] = useState(null);
  const [partidoRevision, setPartidoRevision] = useState(null);

  useEffect(() => {
    let vigente = true;
    setCargando(true);
    setError(null);
    setFiltroEstado(null);
    Promise.all([getResumen(temporada), getPartidos(temporada), getEstadosPartido()])
      .then(([r, p, e]) => {
        if (!vigente) return;
        setResumen(r);
        setPartidos(p.partidos);
        setEstados(indexarEstados(e));
      })
      .catch((err) => vigente && setError(err))
      .finally(() => vigente && setCargando(false));
    return () => { vigente = false; };
  }, [temporada]);

  const guardarPerfil = useCallback(async (cambios) => {
    const guardado = await actualizarPerfil(cambios);
    setResumen((prev) => ({ ...prev, jugador: { ...prev.jugador, ...guardado } }));
  }, []);

  const opcionesFiltro = useMemo(() => contarPorEstado(partidos, estados), [partidos, estados]);
  const grupos = useMemo(
    () => agruparPorModalidad(filtrarPorEstado(partidos, filtroEstado), resumen?.inscripciones),
    [partidos, filtroEstado, resumen],
  );

  if (cargando) return <p className="mz-estado-pagina">Cargando tu zona personal…</p>;

  if (error) {
    return (
      <p className="msg-error mz-estado-pagina" role="alert">
        {error.codigo === 'SIN_JUGADOR'
          ? 'Tu usuario no está vinculado a ningún jugador, así que no tienes zona personal.'
          : error.estado === 401
            ? 'Inicia sesión para ver tu zona personal.'
            : error.message || 'No se pudo cargar tu zona personal.'}
      </p>
    );
  }

  return (
    <div className="mi-zona page-content">
      <header className="page-header">
        <h2>Mi área personal</h2>
        <span className="chip chip-muted">{resumen.temporada.nombre}</span>
      </header>

      <FiltrosPartidos
        opciones={opcionesFiltro} total={partidos.length} seleccionado={filtroEstado}
        estados={estados} onSeleccionar={setFiltroEstado}
      />

      <CabeceraJugador resumen={resumen} onGuardarPerfil={guardarPerfil} />

      {grupos.length === 0 ? (
        <p className="mz-vacio">No estás inscrito en ninguna modalidad en esta temporada.</p>
      ) : (
        grupos.map((g) => (
          <TablaPartidos key={g.modalidadId} modalidad={g.modalidad} partidos={g.partidos} estados={estados} hayFiltro={filtroEstado !== null} onRevision={setPartidoRevision} />
        ))
      )}

      {partidoRevision && <ModalRevision partido={partidoRevision} onCerrar={() => setPartidoRevision(null)} />}
    </div>
  );
}
